<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST">

      <div class="form-group row">
        <div class="offset-sm-3 col-sm-9">
          <p v-if="mode === 'multi'">
            You can assign or unassign <strong v-text="count"></strong> selected journal note template(s).
          </p>
          <p v-else>You can assign, reassign or unassign this journal note template.</p>
          <input v-for="journalNoteTemplateId in journalNoteTemplateIds" type="hidden"
                 name="journal_templates[]" :value="journalNoteTemplateId">
        </div>
      </div>

      <div class="form-group row">
        <label for="assign_clients" class="col-form-label col-sm-3">Clients:</label>
        <div class="col-sm-9">
          <chosen id="assign_clients" name="clients[]"
                  :options="clients"
                  :chosen-options="{allow_single_deselect: true}"
                  :multiple="true"
                  track-by="id"
                  label="name"
                  placeholder="Select client(s)..."
                  class="form-control form-control-sm required"
                  v-model="data.selectedClients"></chosen>
        </div>
      </div>

      <div class="form-group row">
        <label for="assign_action" class="col-form-label col-sm-3">Action:</label>
        <div class="col-sm-9">
          <chosen id="assign_action" name="action"
                  :options="{assign: 'Assign', unassign: 'Unassign'}"
                  class="form-control form-control-sm required"
                  v-model="data.action"></chosen>
        </div>
      </div>

      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">
        <i class="fa fa-fw fa-close"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary" :disabled="!submitEnable" :form="formId">
        <i class="fa fa-fw fa-save"></i> Apply
      </button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
import { mapState } from 'pinia'
import { useCheckboxListStore } from "../../stores/checkboxList"

export default {

  /**
   *
   * Modal form allows to set clients to journal note templates.
   *
   * Input properties:
   *
   * modalId - custom id for modal component.
   * action  - form action URL.
   * title   - form title.
   * mode    - 'single' or 'multi'; in case of 'multi', selected ids should be passed via event.
   * journalNoteTemplate   - serialized journal note template data.
   * clients   - clients array.
   *
   * Usage examples:
   *
   * <assign-journal-template-modal modal-id="assignJournalTemplatesModal"
   *                     action="{{ route('journal-templates.assign-clients') }}"
   *                     :clients="{{ json_encode($clients) }}"
   *                     :journalNoteTemplate="{{ json_encode($journalNoteTemplate) }}"
   *                     mode="single"
   *                     title="Journal Note Templates Assignment">
   *   <a class="btn btn-sm btn-success" href="#" v-modal="'assignJournalTemplatesModal'">
   *     <i class="fa fa-fw fa-users"></i> Assign
   *   </a>
   * </assign-journal-template-modal>
   *
   */

  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'assignJournalTemplatesModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: ""
    },

    mode: {
      required: false,
      type: String,
      default: "single",
    },

    journalNoteTemplate: {
      required: false,
      type: Object,
      default: () => {
        return {};
      }
    },

    clients: {
      required: true,
      type: Array,
    },
  },

  /**
   * Variables (models).
   */
  data() {
    return {
      data: {
        selectedClients: null,
        action: 'assign',
      },
    }
  },

  /**
   * Computed values
   */
  computed: {
    ...mapState(useCheckboxListStore, ['checkedIds', 'checkedCount']),

    count() {
      return this.checkedCount();
    },

    formId() {
      return this.modalId + "-form"
    },

    submitEnable() {
      return this.data.selectedClients?.length && this.data.action;
    },

    journalNoteTemplateIds() {
      return this.mode === 'single' ? [this.journalNoteTemplate.id] : this.checkedIds();
    },

  },
}
</script>
